import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
  isLoading: false,
  allExamGroups: [],
  singleGroup: [],
  isCreatingGroup: false,
  isEditingGroup: false,
  isDeletingGroup: false,
  currentExamGroup: null,
  error: null,
  isLoadingGroup: true,
};

export const examGroupSlice = createSlice({
  name: "examGroup",
  initialState,
  reducers: {
    createGroupStart: (state, action) => {
      state.isCreatingGroup = true;
      state.error = null;
    },
    createGroupSuccess: (state, action) => {
      state.isCreatingGroup = false;
      state.error = null;
    },
    createGroupFailure: (state, action) => {
      state.isCreatingGroup = false;
      state.error = action.payload;
    },
    getAllGroupStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
      state.allExamGroups = [];
    },
    getAllGroupSuccess: (state, action) => {
      state.isLoading = false;
      state.error = null;
      state.allExamGroups = action.payload;
    },
    getAllGroupFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.allExamGroups = [];
    },
    getGroupStart: (state, action) => {
      state.isLoadingGroup = true;
      state.error = null;
    },
    getGroupSuccess: (state, action) => {
      state.isLoadingGroup = false;
      state.singleGroup = action.payload;
      state.error = null;
    },
    getGroupFailure: (state, action) => {
      state.isLoadingGroup = false;
      state.error = action.payload;
    },
    resetGetGroupLoading: (state, action) => {
      state.isLoadingGroup = true;
    },
    editGroupStart: (state, action) => {
      state.isEditingGroup = true;
    },
    editGroupSuccess: (state, action) => {
      state.isEditingGroup = false;
    },
    editGroupFailure: (state, action) => {
      state.isEditingGroup = false;
      state.error = action.payload;
    },
    deleteGroupStart: (state, action) => {
      state.isDeletingGroup = true;
    },
    deleteGroupSuccess: (state, action) => {
      state.isDeletingGroup = false;
    },
    deleteGroupFailure: (state, action) => {
      state.isDeletingGroup = false;
      state.error = action.payload;
    },
    setCurrentExamGroup: (state, action) => {
      state.currentExamGroup = action.payload;
    },
  },
});

export const {
  createGroupStart,
  createGroupSuccess,
  createGroupFailure,
  getAllGroupStart,
  getAllGroupSuccess,
  getAllGroupFailure,
  getGroupStart,
  getGroupSuccess,
  getGroupFailure,
  resetGetGroupLoading,
  editGroupStart,
  editGroupSuccess,
  editGroupFailure,
  deleteGroupStart,
  deleteGroupSuccess,
  deleteGroupFailure,
  setCurrentExamGroup,
} = examGroupSlice.actions;

const persistConfig = {
  key: "examGroup",
  storage,
  whitelist: ["currentExamGroup"],
};

const examGroupReducer = examGroupSlice.reducer;
export default persistReducer(persistConfig, examGroupReducer);
